import UpdatePassword from '../components/UpdatePassword'
import { updatePasswordServiceConfig, logoutServiceConfig } from './shared/config'
import injectWidget from './shared/injectWidget'

const UpdatePasswordWidget = injectWidget({
  widget: UpdatePassword,
  serviceConfig: updatePasswordServiceConfig.concat(logoutServiceConfig),
})

export default UpdatePasswordWidget
